<template>
	<div class="formulaire__rapport">
		<svg fill="#ed844b" class="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 64 80" enable-background="new 0 0 64 64" xml:space="preserve"><g><g><g><path d="M49,64H3c-0.553,0-1-0.447-1-1V1c0-0.553,0.447-1,1-1h46c0.553,0,1,0.447,1,1v62C50,63.553,49.553,64,49,64z M4,62h44V2     H4V62z"/></g><g><path d="M46,61H6c-0.553,0-1-0.447-1-1V4c0-0.553,0.447-1,1-1s1,0.447,1,1v55h38V4c0-0.553,0.447-1,1-1s1,0.447,1,1v56     C47,60.553,46.553,61,46,61z"/></g><g><g><path d="M19.001,6c-0.367,0-0.72-0.202-0.896-0.553l-2-4c-0.247-0.494-0.047-1.095,0.447-1.342      c0.494-0.245,1.094-0.047,1.342,0.447l2,4c0.247,0.494,0.047,1.095-0.447,1.342C19.304,5.966,19.151,6,19.001,6z"/></g><g><path d="M32.999,6c-0.15,0-0.303-0.034-0.446-0.105c-0.494-0.247-0.694-0.848-0.447-1.342l2-4      c0.248-0.494,0.849-0.692,1.342-0.447c0.494,0.247,0.694,0.848,0.447,1.342l-2,4C33.719,5.798,33.366,6,32.999,6z"/></g><g><path d="M33,6H19c-0.553,0-1-0.447-1-1s0.447-1,1-1h14c0.553,0,1,0.447,1,1S33.553,6,33,6z"/></g></g><g><path d="M46,5H33.5c-0.553,0-1-0.447-1-1s0.447-1,1-1H46c0.553,0,1,0.447,1,1S46.553,5,46,5z"/></g><g><path d="M18.5,5H6C5.447,5,5,4.553,5,4s0.447-1,1-1h12.5c0.553,0,1,0.447,1,1S19.053,5,18.5,5z"/></g><g><g><g><g><path d="M15.998,19c-0.265,0-0.528-0.104-0.725-0.311l-0.951-1c-0.381-0.4-0.365-1.033,0.035-1.414        c0.4-0.379,1.033-0.363,1.414,0.035l0.951,1c0.381,0.4,0.365,1.033-0.035,1.414C16.494,18.908,16.246,19,15.998,19z"/></g><g><path d="M15.998,19c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l2.002-2.002        c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-2.002,2.002C16.51,18.902,16.254,19,15.998,19z"/></g></g><g><path d="M16.5,23c-3.584,0-6.5-2.916-6.5-6.5s2.916-6.5,6.5-6.5s6.5,2.916,6.5,6.5S20.084,23,16.5,23z M16.5,12       c-2.481,0-4.5,2.019-4.5,4.5s2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5S18.981,12,16.5,12z"/></g></g><g><path d="M41,15H27c-0.553,0-1-0.447-1-1s0.447-1,1-1h14c0.553,0,1,0.447,1,1S41.553,15,41,15z"/></g><g><path d="M34,19h-7c-0.553,0-1-0.447-1-1s0.447-1,1-1h7c0.553,0,1,0.447,1,1S34.553,19,34,19z"/></g></g><g><g><g><g><path d="M15.998,51c-0.265,0-0.528-0.104-0.725-0.311l-0.951-1c-0.381-0.4-0.365-1.033,0.035-1.414        c0.4-0.379,1.033-0.363,1.414,0.035l0.951,1c0.381,0.4,0.365,1.033-0.035,1.414C16.494,50.908,16.246,51,15.998,51z"/></g><g><path d="M15.998,51c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l2.002-2.002        c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-2.002,2.002C16.51,50.902,16.254,51,15.998,51z"/></g></g><g><path d="M16.5,55c-3.584,0-6.5-2.916-6.5-6.5s2.916-6.5,6.5-6.5s6.5,2.916,6.5,6.5S20.084,55,16.5,55z M16.5,44       c-2.481,0-4.5,2.019-4.5,4.5s2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5S18.981,44,16.5,44z"/></g></g><g><path d="M41,47H27c-0.553,0-1-0.447-1-1s0.447-1,1-1h14c0.553,0,1,0.447,1,1S41.553,47,41,47z"/></g><g><path d="M34,51h-7c-0.553,0-1-0.447-1-1s0.447-1,1-1h7c0.553,0,1,0.447,1,1S34.553,51,34,51z"/></g></g><g><g><g><g><path d="M14.998,35c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.024,0-1.414l3.002-3        c0.391-0.391,1.023-0.391,1.414,0s0.391,1.024,0,1.414l-3.002,3C15.51,34.902,15.254,35,14.998,35z"/></g></g><g><g><path d="M18,35c-0.256,0-0.512-0.098-0.707-0.293l-3.002-3c-0.391-0.39-0.391-1.023,0-1.414s1.023-0.391,1.414,0l3.002,3        c0.391,0.39,0.391,1.023,0,1.414C18.512,34.902,18.256,35,18,35z"/></g></g><g><path d="M16.5,39c-3.584,0-6.5-2.916-6.5-6.5s2.916-6.5,6.5-6.5s6.5,2.916,6.5,6.5S20.084,39,16.5,39z M16.5,28       c-2.481,0-4.5,2.019-4.5,4.5s2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5S18.981,28,16.5,28z"/></g></g><g><path d="M41,31H27c-0.553,0-1-0.447-1-1s0.447-1,1-1h14c0.553,0,1,0.447,1,1S41.553,31,41,31z"/></g><g><path d="M34,35h-7c-0.553,0-1-0.447-1-1s0.447-1,1-1h7c0.553,0,1,0.447,1,1S34.553,35,34,35z"/></g></g><g><g><path d="M58,17c-0.553,0-1-0.447-1-1c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.553-0.447,1-1,1s-1-0.447-1-1c0-1.654,1.346-3,3-3      s3,1.346,3,3C59,16.553,58.553,17,58,17z"/></g><g><path d="M54,51c-0.553,0-1-0.447-1-1V16c0-0.553,0.447-1,1-1s1,0.447,1,1v34C55,50.553,54.553,51,54,51z"/></g><g><path d="M58,51c-0.553,0-1-0.447-1-1V16c0-0.553,0.447-1,1-1s1,0.447,1,1v34C59,50.553,58.553,51,58,51z"/></g><g><path d="M56.001,54c-0.323,0-0.641-0.156-0.833-0.445l-2-3c-0.307-0.46-0.183-1.08,0.277-1.387      c0.461-0.307,1.08-0.183,1.387,0.277l2,3c0.307,0.46,0.183,1.08-0.277,1.387C56.384,53.945,56.191,54,56.001,54z"/></g><g><path d="M55.999,54c-0.19,0-0.383-0.055-0.554-0.168c-0.46-0.307-0.584-0.927-0.277-1.387l2-3      c0.306-0.46,0.926-0.584,1.387-0.277c0.46,0.307,0.584,0.927,0.277,1.387l-2,3C56.64,53.844,56.322,54,55.999,54z"/></g><g><path d="M56,55c-0.553,0-1-0.447-1-1v-1c0-0.553,0.447-1,1-1s1,0.447,1,1v1C57,54.553,56.553,55,56,55z"/></g><g><path d="M58,49h-4c-0.553,0-1-0.447-1-1s0.447-1,1-1h4c0.553,0,1,0.447,1,1S58.553,49,58,49z"/></g><g><path d="M61,20c-0.553,0-1-0.447-1-1c0-0.552-0.448-1-1-1c-0.553,0-1-0.447-1-1s0.447-1,1-1c1.654,0,3,1.346,3,3      C62,19.553,61.553,20,61,20z"/></g><g><path d="M61,32c-0.553,0-1-0.447-1-1V19c0-0.553,0.447-1,1-1s1,0.447,1,1v12C62,31.553,61.553,32,61,32z"/></g><g><path d="M59,18h-1c-0.553,0-1-0.447-1-1s0.447-1,1-1h1c0.553,0,1,0.447,1,1S59.553,18,59,18z"/></g><g><path d="M58,27h-4c-0.553,0-1-0.447-1-1s0.447-1,1-1h4c0.553,0,1,0.447,1,1S58.553,27,58,27z"/></g></g></g></g></svg>
		<h3 class="mt-10">Rapport de suivi</h3>
		<v-form 
			v-model="opt_form.valide"
			mode="aggressive"
			ref="form"
		>
			<v-row>
				<v-col>
					<InputSearchCab 
						@change="cab_change"
						class="mt-8"
						require
					>
					</InputSearchCab>
					<v-text-field 
						outlined
						v-model="cab"
						:rules="opt_form.rules.cab"
						class="mt-4"
						v-show="false"
						id="hidden-searchcab"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col col="12" md="6">
					<v-select
						outlined
						:items="opt_form.liste_satisfaction"
						v-model="satisfaction"
						label="Satisfaction"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.satisfaction"
					></v-select>
				</v-col>
				<v-col col="12" md="6">
					<v-select
						outlined
						:items="opt_form.liste_risque"
						v-model="risque"
						label="Risque"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.risque"
					></v-select>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						label="Commentaire"
						v-model="commentaire"
					></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-select
						outlined
						:items="opt_form.liste_boolean"
						v-model="prise_de_photo"
						label="Prise de photo"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.prise_de_photo"
					></v-select>
				</v-col>
				<v-col>
					<v-select
						outlined
						:items="opt_form.liste_boolean"
						v-model="bdd"
						label="BDD"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.bdd"
					></v-select>
				</v-col>
				<v-col>
					<v-text-field
						outlined
						label="Utilisation de la newsletters ?"
						v-model="newsletter"
						:rules="opt_form.rules.newsletter"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-select
						outlined
						:items="opt_form.liste_stats"
						v-model="stats"
						label="Stats"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.stats"
					></v-select>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						label="Objectif"
						v-model="objectif"
						:rules="opt_form.rules.objectif"
					></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-select
						outlined
						:items="opt_form.liste_modifications"
						v-model="modifications"
						label="Modifications"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.modifications"
					></v-select>
				</v-col>
				<v-col>
					<v-select
						outlined
						:items="opt_form.liste_type_suivi"
						v-model="type_suivi"
						label="Type de suivi"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.type_suivi"
					></v-select>
				</v-col>
				<v-col>
					<v-select
						outlined
						:items="opt_form.liste_present"
						v-model="present"
						label="Présent"
						item-text="label"
						item-value="code"
						:rules="opt_form.rules.present"
					></v-select>
				</v-col>
			</v-row>
			<InputFileUpload
				colorBack="#3d2f59"
				class="mt-2 mb-10"
				@change="files_changes"
			></InputFileUpload>
			<v-btn 
				class="mt-0" 
				depressed 
				color="#ed844b" 
				:dark="opt_form.valide"
				:disabled="!opt_form.valide"
				@click="send"
			>
				Envoyer
			</v-btn>
			<v-btn 
				class="ml-4" 
				depressed 
				@click="$router.go(-1);"
			>
				Retour
			</v-btn>		
		</v-form>
	</div>
</template>

<script>
	import InputSearchCab from '../InputCabSearch.vue'
	import InputFileUpload from '../InputFileUpload.vue'
	import { mapActions, mapMutations } from 'vuex';

	export default {
		name: 'Rapport',
		components : {
			InputSearchCab,
			InputFileUpload
		},
		data: () => ({
			cab: "",
			satisfaction: "SATISFAIT",
			risque: "NUL",
			commentaire: "",
			prise_de_photo: "non",
			bdd: "oui",
			newsletter: "",
			stats: "EN PROGRES",
			objectif: "",
			modifications: "Non",
			type_suivi: "telephone",
			present: "present",
			files: [],
			opt_form: {
				liste_satisfaction : [
					{"code": "TOTALE", "label": "Totale / Très satisfait"},
					{"code": "SATISFAIT", "label": "Satisfait"},
					{"code": "PARTIELLE", "label": "Partielle"},
					{"code": "NULLE", "label": "Nulle / Pas satisfait"},
					{"code": "LITIGE", "label": "Litige"}
				],
				liste_risque : [
					{"code": "NUL", "label": "Nul"},
					{"code": "A SURVEILLER", "label": "A surveiller"},
					{"code": "ELEVE", "label": "Elevé"}
				],
				liste_boolean : [
					{"code": "non", "label": "Non"},
					{"code": "oui", "label": "Oui"}
				],
				liste_stats : [
					{"code": "EN PROGRES", "label": "En progrès"},
					{"code": "STAGNATION", "label": "Stagnation"},
					{"code": "REGRESSION", "label": "Regression"}
				],
				liste_modifications: [
					{"code": "Non", "label": "Non"},
					{"code": "Peu", "label": "Peu"},
					{"code": "Moyen", "label": "Moyen"},
					{"code": "Beaucoup", "label": "Beaucoup"}
				],
				liste_type_suivi : [
					{"code": "telephone", "label": "Par téléphone"},
					{"code": "deplacement", "label": "Déplacement"}
				],
				liste_present : [
					{"code": "present", "label": "Présent"},
					{"code": "absent", "label": "Absent"}
				],
				cab_error : false,
				lazy: false,
				valide: false,
				rules : {
					cab : [
						v => v != "" ? true : "Le cab est requis",
					],
					satisfaction : [
						v => v != "" ? true : "Le champs statisfaction est requis",
					],
					risque : [
						v => v != "" ? true : "Le champs risque est requis",
					],
					prise_de_photo : [
						v => v != "" ? true : "Le champs prise de photo est requis",
					],
					bdd : [
						v => v != "" ? true : "Le champs bdd est requis",
					],
					newsletter : [
						v => v != "" ? true : "Le champs newsletter est requis",
					],
					stats : [
						v => v != "" ? true : "Le champs stats est requis",
					],
					objectif : [
						v => v != "" ? true : "Le champs objectif est requis",
						v => v.length > 5 ? true : "Le champs objectif est trop court"
					],
					type_suivi : [
						v => v != "" ? true : "Le champs type de suivi est requis",
					]
				}
			},
		}),
		created: function() {

		},
		methods: {
			...mapActions('formulaires', [
				"sendRapportSuivi"
			]),
			...mapMutations('formulaires', [
				"setNotif",
				"setNotifMsg"
			]),
			...mapMutations('global', [
				"sendSuccessNotif"
			]),
			files_changes: function(e) {
				this.files = e;
			},
			cab_change: function(e) {
				this.cab = e;
			},
			send: function() {
				var _this = this;

				this.sendRapportSuivi({
					cab 			: this.cab,
					satisfaction 	: this.satisfaction,
					risque 			: this.risque,
					commentaire 	: this.commentaire,
					prise_de_photo 	: this.prise_de_photo,
					bdd 			: this.bdd,
					newsletter 		: this.newsletter,
					stats 			: this.stats,
					objectif 		: this.objectif,
					modifications 	: this.modifications,
					type_suivi 		: this.type_suivi,
					present 		: this.present,
					files 			: this.files.map(x => {
						return x.file_id
					})
				})
				.then(() => {
					_this.sendSuccessNotif("Opération effectuée")
					_this.$router.push('/');
				})
			}
		},
	};
</script>

<style lang="scss">
	.formulaire__rapport {
		width: 80%;
		max-width: 900px;
		border: 4px solid #f1f1f1;
		border-radius: 16px;
		margin-top: 30px;
		padding: 20px;
		margin-left: auto;
		margin-right: auto;
		position: relative;
		overflow: display;
		padding-bottom: 30px;

		.logo
		{
			width: 50px;
			position: absolute;
			margin-left: auto;
			margin-right: auto;
			top: -25px;
			left:0;
			right: 0;
			z-index: 1000;
		}
	}


	@media only screen and (min-width: 701px) and (max-width: 800px) {
		.formulaire__rapport
		{
			width: 50%;
		}
	}

	@media only screen and (min-width: 420px) and (max-width: 700px) {
		.formulaire__rapport
		{
			width: 80%;
		}
	}

	@media only screen and (min-width: 0px) and (max-width: 419px) {
		.formulaire__rapport
		{
			width: 90%;
		}
	}
</style>